import { useEffect, useRef } from "react";

// Adds "is-visible" class to elements with class "reveal" once they enter viewport.
// Uses a MutationObserver so dynamically-added content (e.g. async-fetched WP posts,
// quiz cards, etc.) is also observed and revealed correctly.
export function useReveal() {
  const scope = useRef(null);

  useEffect(() => {
    const root = scope.current || document;

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -40px 0px" }
    );

    const observeAll = () => {
      root.querySelectorAll(".reveal:not(.is-visible)").forEach((el) => io.observe(el));
    };

    observeAll();

    const mo = new MutationObserver(() => observeAll());
    mo.observe(root, { childList: true, subtree: true });

    return () => {
      io.disconnect();
      mo.disconnect();
    };
  }, []);

  return scope;
}
